<template>
    <data-table-group>
        <template v-slot:meta>
            <v-col cols="12">
                <v-text-field v-model="mValue.Title" label="Title" />
            </v-col>
			<v-col cols="12" sm="4" md="3" lg="2" class="d-flex">
				<NumberColumnsTextField v-model="mValue.NumColumns" label="Number of Columns" :tooltip="numColumnsTooltip" />
            </v-col>
		</template>

        <template v-slot:DataTables>
			<DraggableGroupItems
				v-model="mValue.DataTables"
				items-label="Table"
				:items-style="itemsStyle"
				class="full-width"
				@add-item="addItem"
				@delete-item="deleteItem"
			>
				<template v-slot:default="{ item }">
					<v-text-field class="mt-5" label="Title" v-model="item.title"></v-text-field>
					<url-selector v-model="item.csvUrl" label="CSV File" :relative_path="true"></url-selector>
					<v-row>
						<v-col cols="6">
							<v-text-field label="Rank on Column Name" v-model="item.rankOnColumnName"></v-text-field>
						</v-col>
						<v-col cols="6">
							<v-select label="Rank Sort Direction" :items="['Ascending', 'Descending']" v-model="item.rankSortDirection" />
						</v-col>
					</v-row>
					<v-checkbox class="mt-0" v-model="item.filterOnAgentCode" label="filter on Agent Code" false-value="0" true-value="1"></v-checkbox>
				</template>
			</DraggableGroupItems>
        </template>
    </data-table-group>
</template>

<script>
import TextEditor from '../TextEditor.vue'
import ImageSelector from '../ImageSelector.vue'
import UrlSelector from '../UrlSelector.vue'
import DataTableGroup from '@/CMS/views/ContentBlocks/DataTableGroup.vue'
import NumberColumnsTextField from '@/CMS/editor/components/NumberColumnsTextField.vue'
import DraggableGroupItems from '@/CMS/editor/components/DraggableGroupItems.vue'
import { CmsGroupEditorMixin } from '@/CMS/mixins/CmsGroupMixin'

export default {
	components: {
        TextEditor,
        DataTableGroup,
        UrlSelector,
        ImageSelector,
		NumberColumnsTextField,
		DraggableGroupItems,
    },
	mixins: [CmsGroupEditorMixin],
    props: {
		value: { type: Object },
	},
    data () {
        return {
			itemsName: 'DataTables', // override Mixin
        }
    },
    methods: {
		reset () { // override Mixin
			const value = { ...this.mValue }
            if (typeof value.DataTables === 'undefined') {
				value.DataTables = [this.getNewItem()]
            }
			if (typeof value.NumColumns === 'undefined') {
				value.NumColumns = 1
			}
			value.DataTables.map((table) => {
				const item = { ...table }
				if (typeof item.id === 'undefined') {
					this.counter = this.counter + 1
					item.id = this.counter
				}
				return item
			})
            this.mValue = value
        },
		getNewItem () { // override Mixin
			this.counter = this.counter + 1
			return {
                id: this.counter,
                title: '',
                csvUrl: '',
				rankOnColumnName: null,
				rankSortDirection: null,
				filterOnAgentCode: null,
            }
		},
    },
}
</script>
